import React, { FormEvent, useState } from "react";
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import CustomButton from "../../../components/CustomButton";
import { useDispatch } from "react-redux";
import { paymentSlice } from "../../../store/reducer/payment";
import { Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { debounce } from 'lodash';

const getRedirectUrl = (): string => { 
  if (import.meta.env.VITE_APP_ENV === 'dev') {
    return import.meta.env.VITE_APP_HOST + ":" + import.meta.env.VITE_APP_PORT + "/payment/complete";
  } else {
    return import.meta.env.VITE_APP_HOST + "/payment/complete";
  }
}

const CreditCardPayment = () => {
  const stripe = useStripe();
  const elements = useElements();
  const dispatch = useDispatch();
  const redirectUrl = getRedirectUrl();
  const [stripeLoading, setStripeLoading] = useState(true);
  const [disableSubmit, setDisableSubmit] = useState(false);

  const debouncedHandleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    setDisableSubmit(true);
    await handleSubmit();
  }

  const handleSubmit = debounce(async () => {
    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    const result = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: redirectUrl,
      },
    });

    if (result.error) {
      dispatch(paymentSlice.actions.addAlertMessage(result.error.message as string));
    }

    setDisableSubmit(false);
  }, 1000);

  return (
    <>
      { stripeLoading && 
        <Box>
          <CircularProgress />
          <p>Please wait while we connect to our payment processor...</p>
        </Box>
       }
    <form onSubmit={debouncedHandleSubmit}>
      <Box sx={{marginTop: '1.5em', marginBottom: '1.5em'}} >
        <PaymentElement onLoaderStart={() => setStripeLoading(false)}/>
      </Box>
      <CustomButton
        type="submit"
        variant="contained"
        disableElevation={true}
        label={"Submit Payment"}
        disabled={!stripe || disableSubmit}
      />
    </form>
    </>
  );
};

export default CreditCardPayment;
